import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M8 4.75H4.75V19.25H8M16 4.75H19.25V19.25H16M10 17L14 7" vectorEffect="non-scaling-stroke" />
	</SVG>
);
